import React from 'react'

function Education() {
  return (
    <>
      <div id="Education" className='py-24'>
        <div className="Journey">
          <h2 data-aos="zoom-in">My <span className='span3'>Journey</span></h2>
        </div>

        <div className="Main-Joureny pt-20" data-aos="zoom-in">
          <div className="Education-Column">
            <h1 data-aos="fade-right" className='text-4xl font-bold'>Education <span>.</span></h1>
            <div className="Education-Section">
              <div className="Eduction-Details" data-aos="zoom-in">
                <div className="Edu-Date p-4">
                  <h6><span><i className='bx bx-calendar'></i></span> 2019 - 2021</h6>
                  <h3 className='py-2'>Matric Degree <span>.</span></h3>
                  <p>I graduated from matric from Muslim Public High Secondary School with excellent grades. I graduated my Matric Since <span>2019-2021</span>.<br />"<span>
                    Education is the passport to the future, for tomorrow belongs to those who prepare for it today.</span>"</p>
                </div>
              </div>
              <div className="Eduction-Details" data-aos="zoom-in">
                <div className="Edu-Date p-4">
                  <h6><span><i className='bx bx-calendar'></i></span> 2021 - 2023</h6>
                  <h3 className='py-2'>Intermediate Degree <span>.</span></h3>
                  <p>I graduated from matric from Muslim Public High Secondary School with excellent grades. I graduated my Matric Since <span>2021-2023</span>.<br />"<span>
                  An investment in knowledge always pays the best interest.</span>"</p>
                </div>
              </div>
              <div className="Eduction-Details" data-aos="zoom-in">
                <div className="Edu-Date p-4">
                  <h6><span><i className='bx bx-calendar'></i></span> Too Be Continued...</h6>
                  <h3 className='py-2'>Future Degree <span>.</span></h3>
                  <p>Insha'Allah I will continue my Education at this time I'm Learning Different Computer Languages Such as <span>JavaScript</span> ,<span>NodeJS</span> ,<span>Python</span>.</p>
                </div>
              </div>
            </div>
          </div>

          <div className="Exp-Column">
            <h1 data-aos="fade-right" className='text-4xl font-bold'>Experience <span>.</span></h1>
            <div className="Exp-Section">
              <div className="Exp-Details" data-aos="zoom-in">
                <div className="Exp-Date p-4">
                  <h6><span><i className='bx bx-code' ></i> Noman. <i className='bx bx-code-alt' ></i></span></h6>
                  <h3 className='py-2'>Front-End Developer <span>.</span></h3>
                  <p>I am a FrontEnd Web Developer who can create interactive, user-friendly, and responsive designs. I can use the visual and GUI according to your needs through the use of <span>Html</span>,<span> CSS</span>,<span> BootStrap</span>,<span> TailwindCSS</span>,<span> JavaScript</span> &<span> React JS</span>.</p>
                </div>
              </div>
              <div className="Exp-Details" data-aos="zoom-in">
                <div className="Exp-Date p-4">
                  <h6><span><i className='bx bx-terminal' ></i></span></h6>
                  <h3 className='py-2'>Back-End Developer <span>.</span></h3>
                  <p>Backend developer adept in Node.js, crafting robust server-side logic, and database management, ensuring seamless integration with frontend technologies for scalable web applications.</p>
                </div>
              </div>
              <div className="Exp-Details" data-aos="zoom-in">
                <div className="Exp-Date p-4">
                  <h6><span><i className='bx bx-terminal' ></i></span></h6>
                  <h3 className='py-2'>Full Stack Developer <span>.</span></h3>
                  <p>As a full-stack developer, I specialize in creating dynamic and engaging web applications by combining my frontend expertise with backend development skills. With a focus on delivering seamless user experiences and responsive designs, I leverage a wide range of technologies to bring your ideas to life.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </>
  )
}

export default Education
